// extracted by css-extract-rspack-plugin
export default {"cls1":"LettersModal-cls1_Cw9","cls2":"LettersModal-cls2_bgV LettersModal-cls1_Cw9"};